import '@uplink/ui/styles.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { queryClient, TRPCProvider, trpcClient } from './api.ts';
import { PrefsProvider } from './prefs.tsx';
import { bootstrapTelegram, inTelegram, webSignIn } from './telegram.ts';
import { WebRoot } from './web/WebRoot.tsx';

// The Mini App's own subdomain opened in a plain browser: the website is on the main domain
if (!inTelegram && window.location.hostname.startsWith('webapp.')) {
  window.location.replace(
    `https://${window.location.hostname.slice('webapp.'.length)}${window.location.pathname}${window.location.search}`,
  );
}

bootstrapTelegram();

const root = document.getElementById('root')!;
// Статическая разметка нужна поисковикам и пользователям без JavaScript; приложение заменяет её при запуске.
if (root.dataset.prerendered === 'true') root.replaceChildren();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <PrefsProvider>
          {/* Telegram (and the dev browser) authenticate per request; the website signs in first */}
          {webSignIn ? <WebRoot /> : <App />}
        </PrefsProvider>
      </TRPCProvider>
    </QueryClientProvider>
  </StrictMode>,
);
